// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import classNames from 'classnames'
import { SecondaryButton } from '../ui_kit_quickMD/secondary-button/secondarybutton'
import './confirmationpopup.scss'
import closeIcon from '../../images/common/close.png'
import { PrimaryButton } from 'ui_kit_qmd'

const secondaryBtnLabelStyle = { fontWeight: '700' }
const secondaryBtnContainerStyle = { height: 38, width: 225, marginRight: 12 }
const primaryBtnContainerStyle = { height: 60, width: 245, marginLeft: 12 }
export const ConfirmationPopup = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  primaryBtnText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  primaryBtnAction,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  secondaryBtnText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  secondaryBtnAction,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closeAction,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  msg,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  popUpBoxStyle,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  extraView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  buttonWidth,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  id,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  className,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  titleIcon,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isCaution,
}) => (
  <div className={classNames('confirmation-popup-container', { [className]: className })} id={id}>
    <div className='confirmation-popup-box' style={popUpBoxStyle}>
      <div className='confirmation-popup-body'>
        <span className='confirmation-popup-title'>
          {titleIcon ?
            <img className='confirmation-popup-title-icon' src={titleIcon} alt='Icon' />
          : null}
          {title}
        </span>
        {extraView || null}
        <span className='confirmation-popup-message'>{msg}</span>
        <div className='confirmation-popup-button-container'>
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <SecondaryButton
            btnText={secondaryBtnText}
            onPress={secondaryBtnAction}
            labelStyle={secondaryBtnLabelStyle}
            containerStyle={{
              ...secondaryBtnContainerStyle,
              width: buttonWidth || secondaryBtnContainerStyle.width,
            }}
            id={`${secondaryBtnText}button`}
          />
          <PrimaryButton
            btnText={primaryBtnText}
            onPress={primaryBtnAction}
            containerStyle={{
              ...primaryBtnContainerStyle,
              width: buttonWidth || primaryBtnContainerStyle.width,
            }}
            id={`${primaryBtnText}button`}
            isCaution={isCaution}
          />
        </div>
        {closeAction ?
          <input
            type='image'
            src={closeIcon}
            alt='Close'
            className='confirmation-popup-close-img'
            onClick={closeAction}
          />
        : null}
      </div>
    </div>
  </div>
)
ConfirmationPopup.displayName = 'ConfirmationPopup'
